import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { IconButton } from '../IconButton/index';
import { carouselButtonNavigationTypes, carouselButtonArrowTypes, } from './constants';
const arrowBackground = css `
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: ${theme.spacing.x2};
  padding-left: ${theme.spacing.x2};
  padding-right: ${theme.spacing.x2};
  padding-top: ${theme.spacing.x2};
`;
const defaultProps = {
    fullWidth: false,
};
const CarouselButton = ({ direction, fullWidth = defaultProps.fullWidth, fullWidthAt, onClick, }) => {
    const arrowContainerStyles = useMemo(() => (css `
        ${direction === carouselButtonNavigationTypes.previous && css `left: 0;`}
        ${direction === carouselButtonNavigationTypes.next && css `right: 0;`}
        ${styleUtils.buttonReset}
        ${styleUtils.borderBox}
        background: none;
        color: ${theme.colors.gray700};
        ${fullWidth && arrowBackground}
        ${fullWidthAt &&
        theme.media.lessThan(fullWidthAt) `
          ${arrowBackground}
        `}
        height: auto;
        position: absolute;
        top: calc(50%);
        transform: translateY(-50%);
        width: auto;
        z-index: 100;
      `), [
        direction,
        fullWidth,
        fullWidthAt,
    ]);
    const iconType = useMemo(() => (carouselButtonArrowTypes[direction]), [
        direction,
    ]);
    return (_jsx("div", Object.assign({ css: arrowContainerStyles }, { children: _jsx(IconButton, { iconType: iconType, onClick: onClick, size: "large" }) })));
};
const MemoizedCarouselButton = memo(CarouselButton);
export { MemoizedCarouselButton as CarouselButton };
